import {
  Button,
  Col,
  Form,
  Row,
  Select,
  Space,
  Switch,
  Typography,
} from 'antd';
import { StyledContentBackground } from 'components/content-full-screen/content-full-screen';
import { AddCoustmizeModal } from 'features/new-clients/components/modal/coustmize-view';
import { useCreateClients } from 'features/new-clients/use-cases/create.clients';
import { useDropDownFlag } from 'features/new-clients/use-cases/drop-down';
import { useUserContext } from 'features/users';
import { t } from 'i18next';
import { useState } from 'react';

import { AddNewInfo } from './add-new-clients-info';
import { AssignFormField, ClientsFormValues } from './type';
const { Title } = Typography;
type AddAssignProps = {
  onCancel: () => void;
  onSuccess: () => void;
};
type cityName = {
  text: string;
  value: number;
};
export const AddNewClients = ({ onCancel }: AddAssignProps) => {
  const [showModal, setShowModal] = useState(false);
  const [fileList, setFileList] = useState<any[]>([]);
  const [previewImage, setPreviewImage] = useState<string>('');
  const [subpayload, setSubCategoryPayload] = useState('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const { data: Subscription } = useDropDownFlag('Subscription');
  const { user } = useUserContext();
  const { mutate, isLoading } = useCreateClients();
  const onFinish = (formdata: any) => {
    try {
      const file = fileList[0]?.originFileObj;
      const formData = new FormData();
      formData.append('LoggedInUserId', user?.Id);
      formData.append('ClientName', formdata.ClientName);
      formData.append('Email', formdata.Email);
      formData.append('PhoneNumber', formdata.PhoneNumber);
      formData.append('IndustryId', formdata.IndustryId);
      formData.append('BusinessName', formdata.BusinessName);
      formData.append('BusinessWebsite', formdata.BusinessWebsite);
      formData.append('Address', formdata.Address);
      formData.append('CityId', formdata.CityId);
      formData.append('Description', formdata.Description);
      formData.append('SubscriptionId', formdata.SubscriptionId);
      formData.append('SubCategoryAccess', formdata.SubCategoryAccess);
      formData.append('SendMailAccess', formdata.SendMailAccess);
      formData.append('file', file);
      formData.append('FileName', file.name);
      formData.append('ServiceList', JSON.stringify(subpayload));
      mutate(formData, { onSuccess: onCancel });
    } catch (error) {
      console.error('Error updating brand:', error);
    }
  };

  return (
    <StyledContentBackground>
      <Form<ClientsFormValues>
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete='off'
        layout={'vertical'}
      >
        <AddNewInfo
          fileList={fileList}
          setFileList={setFileList}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          previewOpen={previewOpen}
          setPreviewOpen={setPreviewOpen}
        />
        <Row>
          <Title level={2}>Subscription information</Title>
        </Row>
        <Row gutter={12}>
          <Form.Item
            label={'Subscription'}
            rules={[{ required: true, message: 'Subscription is required' }]}
            name={AssignFormField.SubscriptionId}
          >
            <Select
              options={Subscription?.data?.rc.map((item: cityName) => ({
                label: item.text, // Use `label` for the display value
                value: item.value, // Use `value` for the actual value
              }))}
              placeholder='Please Select'
            />
          </Form.Item>
          <Col xs={24} lg={12}>
            <Form.Item
              label={t('newclient.formFields.subscriptioninfo.subscription')}
              name='SubCategoryAccess'
            >
              <Switch />
            </Form.Item>
            <Form.Item label={'Send Mail'} name='SendMailAccess'>
              <Switch />
            </Form.Item>
            <Form.Item label={'Coustmize Access'}>
              <Button type='primary' onClick={() => setShowModal(true)}>
                Select
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Space size={40}>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type='primary' htmlType='submit' loading={isLoading}>
              {t('newclient.formFields.submitbutton.button')}
            </Button>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button htmlType='submit'>
              {t('newclient.formFields.cancel.button')}
            </Button>
          </Form.Item>
        </Space>
      </Form>
      {/* Modal for send Mail */}
      {showModal && (
        <AddCoustmizeModal
          onClose={() => setShowModal(false)}
          setSubCategoryPayload={setSubCategoryPayload}
        />
      )}
    </StyledContentBackground>
  );
};
